import React from 'react';

/**
 * Inline empty-state placeholder used inside cards (no full-page empty
 * states, no images). Centred icon-in-circle + title + description.
 *
 * Consumers (genuinely shared — 4 callers):
 *   • FindAgentsBar         (no agents found)
 *   • PendingTabContent     (no incoming / no sent)
 *   • PeopleYouMayKnowCard  (no suggestions)
 *   • MyConnectionsCard     (no connections / no matches)
 *
 * Pure presentational — no state, no side effects.
 */
const EmptyInline = ({ icon, title, description }) => (
    <div className="flex flex-column align-items-center text-center py-5 gap-3">
        <div
            className="flex align-items-center justify-content-center border-circle"
            style={{ width: '3rem', height: '3rem', backgroundColor: 'var(--surface-100)' }}
        >
            <i className={`pi ${icon} text-500`} style={{ fontSize: '1.2rem' }} aria-hidden="true" />
        </div>
        <div>
            <h4 className="text-900 font-semibold m-0 mb-1">{title}</h4>
            <p className="text-600 text-sm m-0" style={{ maxWidth: '24rem' }}>
                {description}
            </p>
        </div>
    </div>
);

export default React.memo(EmptyInline);
